<template>
  <div class="form-container">
    <div
      v-if="permissionFilter.includes(profile.roles.name)"
      class="mb-3 d-flex justify-content-end align-items-center"
    >
      <div class="filter">
        <b-row>
          <b-col>
            <b-form-group
              label="Company"
              label-size="sm"
              content-cols-sm="8"
              label-for="input-horizontal"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="company"
                :options="companyOptions"
                placeholder="Select Company"
                value-field="id"
                text-field="name"
                size="sm"
                @change="$refs.workProgress.refresh()"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                  >
                    All Company
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <filters
      :options="contractorOptions"
      @apply ="(filters) => applyFilters(filters)"
      @reset="resetFilters"
    />
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>List Kemajuan Pekerjaan</div>
      <div>
        <span>Show</span>
        <b-form-select
          v-model="perPage"
          :options="perPageOptions"
          class="page-option ml-2 mr-2 w-auto"
        />
        <span>Entries</span>
      </div>
      <b-form-group class="m-0">
        <b-form-input
          v-model="search"
          placeholder="Search..."
          @change="$refs.workProgress.refresh()"
          size="sm"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-table
      hover
      class="mb-4"
      thead-class="table-list-header"
      empty-text="No data"
      ref="workProgress"
      :items="fetchWorkProgress"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="isBusy"
      @row-clicked="goDetail"
      sort-icon-left
      show-empty
      responsive
    >
      <template v-slot:table-busy>
        <div class="text-center my-4">
          <b-spinner variant="info" class="spinner-lg" />
        </div>
      </template>
      <template v-slot:cell(no)="items">
        {{ items.index + 1 }}
      </template>
      <template #cell()="{ value, item }">
        <a class="d-block h-100 text-dark" :href="`/summary-resume-volume-work/${item.id}/detail`">
          {{ value }}
        </a>
      </template>
      <template #cell(status)="items">
        <div :class="statusChange(items.item.status)">{{ items.item.status }}</div>
      </template>
    </b-table>
    <div class="d-flex justify-content-end align-items-center">
      <span class="show-entries mr-auto ml-4">
        {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
      </span>
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        pills
        hide-goto-end-buttons
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Filters from './Filter'

export default {
  components: {
    Filters
  },

  data: () => ({
    profile: JSON.parse(localStorage.getItem('profile')),
    isBusy: false,
    isEdit: false,
    search: '',
    currentPage: localStorage.getItem('currentPage') ?? 1,
    perPage: 10,
    totalRows: localStorage.getItem('totalRows') ?? 0,
    sortBy: 'periode',
    sortDesc: true,
    text: '',
    fields: [
      { key: 'no', label: 'No', sortable: true, thStyle: 'width: 70px', tdClass: 'text-center', thClass: 'text-center' },
      { key: 'periode_doc', label: 'Period', sortable: true },
      { key: 'company_name', label: 'Company Name', sortable: true },
      { key: 'contractor_name', label: 'Contractor', sortable: true },
      { key: 'contract_number', label: 'Contract Number', sortable: true },
      { key: 'contract_type', label: 'Contract Type', sortable: true },
      { key: 'status', label: 'Status', sortable: true }
    ],
    items: [],
    perPageOptions: [
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 30, text: '30' }
    ],
    stringifiedFilter: '',
    contractorOptions: [],
    companyOptions: [],
    permissionFilter: [
      'Super Admin',
      'Finance Jakarta',
      'Administrator'
    ],
    company: null
  }),
  created() {
    this.fetchContractorOption()
    this.fetchCompany()
  },
  methods: {
    async fetchWorkProgress() {
      const data = await api.summaryResumeVolumeWork.list({
        sort_dir: this.sortDesc ? 'DESC' : 'ASC',
        page: this.currentPage,
        limit: this.perPage,
        search: this.search,
        company_id: this.company,
        filter_value: this.stringifiedFilter
      })
      this.totalRows = data ? data.count : 100
      this.items = data ? data.rows : []
      this.items.map(d => {
        if (!d.has_summary && d.status === 'Approved') {
          d._rowVariant = 'success'
        }
      })
      localStorage.removeItem('currentPage', this.currentPage)
      localStorage.removeItem('totalRows', this.totalRows)

      return this.items
    },
    async fetchContractorOption() {
      try {
        const data = await api.contractor.list()
        this.contractorOptions = data
      } catch (error) {}
    },
    async fetchCompany() {
      try {
        this.companyOptions = await api.company.list_active()
      } catch ({ response }) {
        this.error = response.data.message
      }
    },
    applyFilters(filters) {
      if (!filters.periode.length) {
        filters.periode = []
        this.stringifiedFilter = ''
      }
      if (!filters.contractorId) {
        filters.contractorId = null
        this.stringifiedFilter = ''
      }
      if (filters.periode[0] && filters.periode[1] && filters.contractorId) {
        this.stringifiedFilter = `contractor_name:${filters.contractorId},periode:${filters.periode[0]};${filters.periode[1]}`
      } else if (filters.periode[0] && filters.periode[1]) {
        this.stringifiedFilter = `periode:${filters.periode[0]};${filters.periode[1]}`
      } else if (filters.contractorId) {
        this.stringifiedFilter = `contractor_name:${filters.contractorId}`
      }
      this.$refs.workProgress.refresh()
    },
    resetFilters() {
      this.stringifiedFilter = ''
      this.$refs.workProgress.refresh()
    },
    goDetail(item) {
      localStorage.setItem('currentPage', this.currentPage)
      localStorage.setItem('totalRows', this.totalRows)
      this.$router.push({ path: `/summary-resume-volume-work/${item.id}/detail` })
    },
    statusChange(status) {
      if (status.includes('Draft')) {
        return 'draft'
      } else if (status.includes('Approved')) {
        return 'approved'
      } else if (status.includes('Revise')) {
        return 'revised'
      } else if (status.includes('Waiting Approval')) {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
}
.text-selected {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 2px;
}
.label-progress {
  color: #1A051D;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  margin-left: 15px;
}

.progress-bar {
  background-color: #00B4A5;
  border-radius: 6px;
  width: 90px;
  height: 12px;
}

.progress {
  background-color: #EAE7F3;
  border-radius: 6px;
  width: 100px;
  height: 12px;
  flex: 1 0 auto;
}

.percentage {
  display: flex
}
</style>
